import { FeatureCollection } from 'geojson';
import { useEffect, useState } from 'react';
import { settings } from 'settings';
import { Region } from 'types/orderTypes';
import Fetch from '../utils/fetch';

/* This is to fetch AreaOverlay to show it in the map */
/* The map will highlight the available area in the specific region */
export const useAreaOverlay = (region: Region, disabled?: boolean) => {
  const [areaOverlay, setAreaOverlay] = useState<FeatureCollection | null>(
    null
  );

  useEffect(() => {
    const fetchAreaOverlay = async () => {
      try {
        const response = await Fetch.get({
          url: `${settings.newApiUrl}/availability/area-overlay/${region}`,
        });

        if (response.ok) {
          const result: FeatureCollection = await response.json();
          setAreaOverlay(result);
        }
      } catch (e) {
        /* When the AreaOverlay is not fetched properly, we just don't show it in the map */
        /* It should not blocking any user interaction */
        console.log('Error fetching the Area Overlay', e);
        setAreaOverlay(null);
      }
    };

    !disabled && fetchAreaOverlay().catch();
  }, [region, disabled]);

  return areaOverlay;
};
